<template>
  <div class="scroll-logo-box">
    <ul class="scroll-logo-cont" :style="`animation-duration: ${logoData.length * 2}s;`">
      <li class="scroll-logo-item" v-for="(item,index) in logoData" :key="index">
        <img :src="sub" alt="" v-for="(sub,subIdx) in item.imgs" :key="subIdx" class="logo-img">
      </li>
      <!-- 循环衔接副本 -->
      <li class="scroll-logo-item" v-for="(item,index) in logoData" :key="index+'copy'">
        <img :src="sub" alt="" v-for="(sub,subIdx) in item.imgs" :key="subIdx+'copy'" class="logo-img">
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'scrollLogo',
  data() {
    return {
      animate: false,
      logoData: [
        {
          imgs: [
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102205727.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102205793.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102205856.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102205921.png',
          ]
        },{
          imgs: [
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102205990.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206048.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206048.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206161.png',
          ]
        },{
          imgs: [
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206222.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206284.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206341.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206401.png',
          ]
        },
        {
          imgs: [
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206466.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206522.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206581.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206646.png',
          ]
        },
        {
          imgs: [
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206714.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206772.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206826.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206886.png',
          ]
        },{
          imgs: [
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102206943.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207010.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207121.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207175.png',
          ]
        },
        {
          imgs: [
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207231.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207300.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207376.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207433.png',
          ]
        },
        {
          imgs: [
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207485.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207542.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207603.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207668.png',
          ]
        },
        {
          imgs: [
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207735.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207788.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207854.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207911.png',
          ]
        },
        {
          imgs: [
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102207980.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102208035.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102208086.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102208138.png',
          ]
        },
        {
          imgs: [
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102208194.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102208274.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102208335.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102208387.png',
          ]
        },
        {
          imgs: [
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102208445.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102208514.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102208574.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102208648.png',
          ]
        },
        {
          imgs: [
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102208708.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102208785.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660102208856.png',
            'https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/08/1660212783168.jpg'
          ]
        }
      ]
    }
  },
  mounted () {
  },
  methods: {

  }
}
</script>
<style lang="stylus" scoped>
  .scroll-logo-box {
    width: 670px;
    height: 450px;
    overflow:hidden;
    .scroll-logo-cont {
      width: fit-content;
      white-space: nowrap; 
      animation-name: seamless-scrolling; 
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      display: flex;
      align-items: flex-start;
      align-items: center;
      .scroll-logo-item {
        display: flex;
        flex-direction: column;
        margin-right: 20px;
        height: 400px;
        .logo-img {
          width: 280px;
          height: 100px;
          margin-bottom: 16px;
        }
      }
    }
  }
  .anim{
    transition: all 0.8s linear;
  }
  @keyframes seamless-scrolling {
    0% {
      transform: translateX(0px);
    }
    100% {
      transform: translateX(-50%);
    }
  }
</style>